<template>
  <svg
    width="23"
    height="14"
    viewBox="0 0 23 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 0C5.843 0 4.5 1.343 4.5 3C4.5 4.657 5.843 6 7.5 6C9.157 6 10.5 4.657 10.5 3C10.5 1.343 9.157 0 7.5 0ZM15.5 0C13.843 0 12.5 1.343 12.5 3C12.5 4.657 13.843 6 15.5 6C17.157 6 18.5 4.657 18.5 3C18.5 1.343 17.157 0 15.5 0ZM7.5 2C8.051 2 8.5 2.449 8.5 3C8.5 3.551 8.051 4 7.5 4C6.949 4 6.5 3.551 6.5 3C6.5 2.449 6.949 2 7.5 2ZM15.5 2C16.051 2 16.5 2.449 16.5 3C16.5 3.551 16.051 4 15.5 4C14.949 4 14.5 3.551 14.5 3C14.5 2.449 14.949 2 15.5 2ZM7.5 8C4.5 8 0.5 9.464 0.5 11.5V14H13.5781H14.5H22.5V11.5C22.5 9.464 18.5 8 15.5 8C14.2159 8 12.7617 8.28294 11.5039 8.75C10.2438 8.28175 8.78671 8 7.5 8ZM7.5 10C9.86 10 12.12 11.0256 12.5 11.5996V12H2.5V11.5996C2.88 11.0256 5.14 10 7.5 10ZM15.5 10C17.86 10 20.12 11.0256 20.5 11.5996V12H14.5V11.5C14.5 11.0182 14.2703 10.57 13.8887 10.1641C14.4083 10.0693 14.9448 10 15.5 10Z"
      fill="#939393"
    />
  </svg>
</template>

<script>
/**
 * @fileoverview Users Icon
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

export default {
  name: "UsersIcon",
};
</script>

<style lang="scss" scoped>
</style>